<dx-popup
    #updatePaymentPopup
    minWidth="150px"
    minHeight="150px"
    width="30%"
    height="20%"
    [title]="title"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="false"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onShown()"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'" id="updatePayment">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div class="column-container">
                        <div class="full-width">
                            Post Date
                            <sup class="cc-text-required">*</sup>
                        </div>
                        <div class="full-width">
                            <dx-date-box
                                type="date"
                                [elementAttr]="{ class: 'full-width' }"
                                [openOnFieldClick]="true"
                                [showClearButton]="true"
                                [(value)]="postDate"
                            ></dx-date-box>
                        </div>
                    </div>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="button-container">
                        <div class="left-content">
                            <dx-button
                                text="Cancel"
                                type="default"
                                [icon]="iconCancel"
                                (onClick)="onCancelClick()"
                            ></dx-button>
                        </div>
                        <div class="right-content">
                            <dx-button text="Yes" type="success" [icon]="iconYes" (onClick)="onYesClick()"></dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#updatePayment' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
